{
  "appMeta": {
    "title": "dTIMS Licences",
    "description": "dTIMS Licences — gérer les licences individuelles et organisationnelles sur la plateforme dTIMS."
  },
  "layout": {
    "title": "Licences",
    "description": "Gérer les licences individuelles et organisationnelles, et configurer les plans de licence.",
    "navigation": {
      "home": "Accueil",
      "licenses": "Licences",
      "individual": "Individuel",
      "organizational": "Organisationnel",
      "plans": "Plans",
      "roles": "Rôles & Autorisations"
    }
  },
  "authCallback": {
    "logoAlt": "Logo Deighton",
    "exchanging": {
      "title": "Finalisation de la connexion…",
      "subtext": "Échange du code d'autorisation. Veuillez patienter."
    },
    "authenticated": {
      "title": "Connexion réussie",
      "subtext": "Redirection vers l'application…"
    },
    "processing": {
      "title": "Traitement…"
    },
    "error": {
      "title": "Échec de la connexion",
      "subtext": "Une erreur s'est produite lors de la connexion.",
      "iconLabel": "Icône d'erreur",
      "showDetails": "Afficher les détails techniques",
      "detailsRegionLabel": "Détails techniques de l'erreur",
      "retry": "Réessayer",
      "retryAriaLabel": "Retourner à la connexion et réessayer"
    }
  },
  "common": {
    "cancel": "Annuler",
    "save": "Enregistrer",
    "close": "Fermer",
    "edit": "Modifier",
    "delete": "Supprimer",
    "remove": "Retirer",
    "add": "Ajouter",
    "undo": "Annuler",
    "active": "Actif",
    "inactive": "Inactif",
    "enabled": "Activé",
    "disabled": "Désactivé",
    "dismiss": "Ignorer"
  },
  "dashboard": {
    "title": "Tableau de Bord",
    "subtitle": "Aperçu de la gestion de vos licences",
    "loading": "Chargement des données du tableau de bord...",
    "error": "Échec du chargement des données du tableau de bord :",
    "sessionExpired": "Votre session a expiré. Veuillez vous reconnecter pour continuer.",
    "sessionExpiredAction": "Se reconnecter",
    "permissionDenied": "Vous n'avez pas l'autorisation de consulter ces données. Contactez un administrateur locataire si vous avez besoin d'un accès.",
    "stats": {
      "totalUsers": "Utilisateurs Totaux",
      "totalLicenses": "Licences Totales",
      "plans": "Plans",
      "roles": "Rôles & Autorisations",
      "seatUtilization": "Utilisation des Places",
      "active": "actif(s)",
      "of": "de",
      "used": "utilisé(s)"
    },
    "buttons": {
      "users": "Utilisateurs",
      "manageLicenses": "Gérer les Licences",
      "managePlans": "Gérer les Plans",
      "manageRoles": "Gérer les Rôles"
    },
    "expiringCard": {
      "title": "Expiration Prochaine",
      "days": "jours",
      "noExpiring": "Aucune licence n'expire dans les 30 prochains jours"
    },
    "distributionCard": {
      "title": "Distribution des Licences",
      "seats": "places",
      "noData": "Aucune donnée de licence disponible"
    }
  },
  "individualLicense": {
    "title": "Gestion des Utilisateurs",
    "subtitle": "Gérer les attributions de licences individuelles",
    "dialog": {
      "title": "Licence Individuelle",
      "username": "Nom d'utilisateur",
      "email": "Courriel",
      "environment": "Environnement",
      "displayName": "Nom d'affichage",
      "organization": "Organisation",
      "assigned": "Attribué",
      "licenseName": "Nom de la Licence",
      "planType": "Type de Plan",
      "currentUsers": "Utilisateurs Actuels",
      "maxUsers": "Utilisateurs Maximum",
      "activated": "Activé",
      "expires": "Expire",
      "atCapacity": "La licence est à pleine capacité",
      "noLicenses": "Aucune licence disponible pour cette organisation",
      "loadingLicenses": "Chargement des licences disponibles..."
    }
  },
  "organizationLicense": {
    "title": "Gestion des Licences",
    "subtitle": "Gérer les licences organisationnelles et les attributions de places",
    "dialog": {
      "title": "Licences Organisationnelles",
      "clientName": "Nom du Client",
      "clientId": "ID du Client",
      "planName": "Nom du Plan",
      "licenseLevel": "Niveau de Licence",
      "licenseKey": "Clé de Licence",
      "quantity": "Quantité",
      "startDate": "Date de Début",
      "endDate": "Date de Fin",
      "addNewLicense": "Ajouter une Nouvelle Licence",
      "environment": "Environnement",
      "status": "Statut",
      "exceedsPlanLimit": "Une ou plusieurs licences dépassent la limite d'utilisateurs de leur plan. Vous pouvez réduire mais pas augmenter ces valeurs."
    },
    "deleteDialog": {
      "title": "Supprimer la Licence",
      "cannotDelete": "Impossible de supprimer cette licence",
      "cannotDeleteReasons": "ne peut pas être supprimé pour les raisons suivantes :",
      "deactivateFirst": "Veuillez désactiver la licence et retirer tous les utilisateurs avant de la supprimer.",
      "confirmTitle": "Supprimer \"{{planName}}\" pour \"{{tenantName}}\" ?",
      "confirmMessage": "Cette licence n'a aucun utilisateur attribué et n'est pas active. Cette action est irréversible.",
      "deleteLicense": "Supprimer la Licence"
    },
    "modulesDialog": {
      "title": "Fonctionnalités de la Licence",
      "planName": "Nom du Plan",
      "planType": "Type de Plan",
      "licenseId": "ID de la Licence",
      "trial": "Essai",
      "noFeatures": "Aucune fonctionnalité associée à cette licence"
    },
    "toasts": {
      "mixedTenantWarning": "Veuillez sélectionner des licences du même client pour les modifier ensemble.",
      "dismiss": "Fermer"
    }
  },
  "plans": {
    "title": "Plans",
    "subtitle": "Configurer les fonctionnalités et les tarifs des plans",
    "addPlan": "Ajouter un Plan",
    "searchPlans": "Rechercher des plans...",
    "filterByType": "Filtrer par Type",
    "loading": "Chargement des plans...",
    "features": "Fonctionnalités :",
    "ofEnabled": "de {{total}} activées",
    "created": "Créé :",
    "featuresConfiguration": "Configuration des Fonctionnalités",
    "noFeatures": "Aucune fonctionnalité configurée pour ce plan",
    "noPlansFound": "Aucun plan trouvé",
    "adjustFilters": "Essayez d'ajuster vos filtres",
    "noPlansCreated": "Aucun plan n'a encore été créé",
    "dialog": {
      "addTitle": "Ajouter un Plan",
      "editTitle": "Modifier le Plan",
      "planName": "Nom du Plan",
      "planStatus": "Statut du Plan",
      "description": "Description",
      "planType": "Type de Plan",
      "maxUsers": "Utilisateurs Maximum",
      "validFrom": "Valide à Partir du",
      "validTo": "Valide Jusqu'au",
      "featureConfiguration": "Configuration des Fonctionnalités",
      "noFeatures": "Aucune fonctionnalité disponible",
      "planFeatures": "Fonctionnalités du Plan",
      "planFeaturesSubtitle": "Gérer les fonctionnalités incluses dans ce plan",
      "availableFeatures": "Fonctionnalités Disponibles",
      "willBeAdded": "Sera ajoutée",
      "willBeRemoved": "Sera retirée",
      "removeFromPlan": "Retirer du plan",
      "noFeaturesAssigned": "Aucune fonctionnalité assignée à ce plan",
      "allFeaturesAdded": "Toutes les fonctionnalités ont été ajoutées à ce plan",
      "maxUsersWarning": "{{count}} licence(s) dépassent actuellement la limite d'Utilisateurs Maximum. Les licences existantes ne seront pas affectées."
    },
    "deleteDialog": {
      "title": "Supprimer le Plan",
      "checking": "Vérification des dépendances...",
      "cannotDelete": "Impossible de supprimer ce plan",
      "inUseBy": "est actuellement utilisé par",
      "license": "licence",
      "licenses": "licences",
      "reassignFirst": "Veuillez réattribuer ou supprimer ces licences avant de supprimer ce plan.",
      "affectedLicenses": "Licences Affectées :",
      "confirmTitle": "Supprimer \"{{planName}}\" ?",
      "confirmMessage": "Ce plan n'a aucune dépendance de licence active. Cette action est irréversible.",
      "deletePlan": "Supprimer le Plan"
    }
  },
  "roles": {
    "title": "Rôles & Autorisations",
    "subtitle": "Gérer les rôles des utilisateurs de la plateforme et configurer le ciblage du contrôle d'accès",
    "type": {
      "governance": "Gouvernance",
      "operational": "Opérationnel",
      "custom": "Personnalisé"
    },
    "splitPanel": {
      "title": "Vue Panneau Séparé des Rôles",
      "subtitle": "Utilisateurs à gauche, attribution des rôles à droite",
      "searchUsers": "Rechercher des utilisateurs...",
      "emptyStateTitle": "Aucun Utilisateur Sélectionné",
      "emptyStateDesc": "Sélectionnez un utilisateur dans la liste à gauche pour gérer ses attributions de rôles.",
      "saveChanges": "Enregistrer les modifications",
      "saving": "Enregistrement…",
      "reset": "Réinitialiser",
      "rolesAssigned": "{{count}} rôles attribués",
      "roleAssigned": "1 rôle attribué",
      "noRolesAssigned": "Aucun rôle attribué",
      "viewRoleDetails": "Voir les détails du rôle",
      "assignedUsers": "Utilisateurs assignés ({{count}})",
      "assignedUsersPartial": "Utilisateurs avec ce rôle ({{count}} affichés depuis la liste chargée)",
      "assignedUsersOverflow": "+ {{count}} de plus non affichés",
      "noUsersAssigned": "Aucun utilisateur assigné à ce rôle actuellement.",
      "permissionsHierarchy": "Hiérarchie des autorisations",
      "noPermissions": "Aucune autorisation associée à ce rôle.",
      "descriptionHeader": "Description",
      "noDescription": "Aucune description fournie.",
      "loadingUsers": "Chargement des utilisateurs…",
      "loadMore": "Charger plus",
      "noUsersMatchSearch": "Aucun utilisateur ne correspond à la recherche",
      "saveSuccess": "Attributions de rôles enregistrées avec succès.",
      "savePartial": "{{succeeded}} modification(s) réussie(s), {{failed}} échec(s).",
      "saveError": "Échec de l'enregistrement des modifications.",
      "saveUnauthorized": "Vous n'avez pas l'autorisation d'effectuer une ou plusieurs de ces modifications de rôle.",
      "loadError": "Erreur lors du chargement des paramètres des rôles.",
      "globalAdminRoleReadOnly": "Seul un administrateur global peut attribuer ou retirer le rôle d'administrateur global.",
      "rolesReadOnly": "Vous avez un accès en lecture seule aux rôles. Contactez un administrateur locataire pour demander des modifications.",
      "permissionsPreviewNotice": "La liste des autorisations est un aperçu jusqu'à ce que l'API des rôles expose les autorisations par rôle.",
      "bulk": {
        "enterBulk": "Attribution groupée de rôles",
        "exitBulk": "Quitter le mode groupé",
        "singleMode": "Sélection individuelle — choisissez un utilisateur pour modifier ses rôles",
        "selectAll": "Tout sélectionner",
        "selectedCount": "{{count}} utilisateurs sélectionnés",
        "title": "Attribution groupée de rôles",
        "emptyStateTitle": "Aucun utilisateur sélectionné",
        "selectUsersHint": "Sélectionnez un ou plusieurs utilisateurs dans la liste à gauche pour leur attribuer des rôles.",
        "clearSelection": "Effacer la sélection",
        "applyButton": "Appliquer à {{count}} utilisateurs",
        "nothingToAssign": "Aucune modification à appliquer pour les utilisateurs sélectionnés.",
        "applySuccess": "{{count}} modification(s) de rôle appliquée(s) à {{users}} utilisateurs.",
        "applyPartial": "{{succeeded}} modification(s) réussie(s), {{failed}} échec(s).",
        "applyError": "Échec de l'application des modifications de rôle.",
        "dialog": {
          "title": "Confirmer les modifications de rôle",
          "message": "Les modifications suivantes seront appliquées à {{count}} utilisateurs :",
          "assigning": "Attribution",
          "removing": "Retrait",
          "confirm": "Appliquer les modifications"
        }
      },
      "filter": {
        "buttonTooltip": "Filtrer et trier les utilisateurs",
        "buttonAriaLabel": "Filtrer et trier les utilisateurs",
        "buttonAriaLabelWithCount": "Filtrer et trier les utilisateurs, {{count}} actifs",
        "title": "Filtres et tri",
        "clearAll": "Tout effacer",
        "sortBy": "Trier par",
        "sortName": "Nom",
        "sortEmail": "Courriel",
        "sortRole": "Rôle",
        "sortAscName": "↑ A-Z",
        "sortDescName": "↓ Z-A",
        "sortAscEmail": "↑ A-Z",
        "sortDescEmail": "↓ Z-A",
        "sortAscRole": "↑ A-Z",
        "sortDescRole": "↓ Z-A",
        "roleCategory": "Rôle",
        "governance": "Gouvernance",
        "operational": "Opérationnel",
        "custom": "Personnalisé",
        "status": "Statut",
        "statusAll": "Tous",
        "statusHasRole": "A un rôle",
        "statusNoRole": "Sans rôle",
        "includeCrossTenant": "Tous les tenants",
        "usersShown": "{{shown}} utilisateurs affichés",
        "usersShownWithMore": "{{shown}} utilisateurs affichés (plus disponibles)"
      }
    },
    "dialog": {
      "governanceRolesHeader": "Rôles de Gouvernance",
      "governanceRolesBadge": "Administratif",
      "operationalRolesHeader": "Rôles Opérationnels",
      "operationalRolesBadge": "Accès au quotidien",
      "customRolesHeader": "Rôles Personnalisés",
      "customRolesBadge": "Spécifique au client",
      "noRolesAvailable": "Aucun rôle disponible"
    }
  }
}
